import React from 'react';
import { ReactComponent as Home } from '../images/icons/menu/Home.svg';
import { ReactComponent as Parameters } from '../images/icons/menu/Parameters.svg';
import { ReactComponent as Book } from '../images/icons/Book.svg';
import { ReactComponent as PriceTag } from '../images/icons/menu/PriceTagRegular.svg';
import { ReactComponent as Trophy } from '../images/icons/menu/Trophy.svg';
import { ReactComponent as Calendar } from '../images/icons/menu/Calendar.svg';
import { ReactComponent as League } from '../images/icons/menu/League.svg';
import { ReactComponent as TwoPersons } from '../images/icons/menu/TwoPersons.svg';
import { ReactComponent as Link } from '../images/icons/menu/LinkRegular.svg';
import {
  AdminModuleTabs,
  AdminModulesV2RelativeRoutes,
  AdminPagesRelativeRoutes,
  AnalyticsTabsRelativeRoutes,
  CertificationsTabsRelativeRoutes,
  DefaultRoutes,
  OrganizationTabsRelativeRoutes,
  ProfileTabsRelativeRoutes,
} from 'Routes';
import { SideNavItem } from '@trackman/web-shared-components/components/SideNav/SideNav';
import i18n from 'i18next';

export const getMenuItems = (isUserInOrganization: boolean, isUserAdmin: boolean) => {
  const baseMenuItems = [
    {
      id: '/Home',
      label: i18n.t('Home', { ns: 'homePage' }),
      StartIcon: React.createElement(Home),
      href: DefaultRoutes.Home,
    },
    {
      id: '/TrackmanParameters',
      label: i18n.t('TrackmanParameters', { ns: 'trackmanParameters' }),
      StartIcon: React.createElement(Parameters),
      href: DefaultRoutes.TrackmanParameters,
    },
    {
      id: '/LearningHub',
      label: i18n.t('LearningHub', { ns: 'learningHub' }),
      StartIcon: React.createElement(Book),
      href: DefaultRoutes.LearningHub,
    },
    {
      id: '/Webshop',
      label: i18n.t('Webshop', { ns: 'general' }),
      StartIcon: React.createElement(PriceTag),
      href: DefaultRoutes.Webshop,
    },
    {
      id: '/MastersAndPartners',
      label: i18n.t('MastersAndPartners', { ns: 'general' }),
      StartIcon: React.createElement(Trophy),
      href: DefaultRoutes.Certifications,
    },
    {
      id: '/TrackmanEvents',
      label: i18n.t('Events', { ns: 'trackmanEvents' }),
      StartIcon: React.createElement(Calendar),
      href: DefaultRoutes.TrackmanEvents,
    },
  ];

  const userInOrganizationMenuItems = isUserInOrganization
    ? [
        ...baseMenuItems,
        {
          id: '/Organization',
          label: i18n.t('Organization', { ns: 'general' }),
          StartIcon: React.createElement(League),
          href: DefaultRoutes.Organization,
        },
      ]
    : baseMenuItems;

  const adminMenuItems = isUserAdmin
    ? [
        ...userInOrganizationMenuItems,
        {
          id: '/Admin',
          label: i18n.t('Admin', { ns: 'general' }),
          StartIcon: React.createElement(TwoPersons),
          href: DefaultRoutes.Admin,
          subitems: getAdminSubmenuItems(),
        },
      ]
    : userInOrganizationMenuItems;

  const menuItemsToRender = [
    ...adminMenuItems,
    {
      id: '/Resources',
      label: i18n.t('Resources', { ns: 'general' }),
      StartIcon: React.createElement(Link),
      subitems: getResourcesSubmenuItems(),
    },
  ];
  return menuItemsToRender as SideNavItem[];
};

const getAdminSubmenuItems = () => {
  return [
    {
      id: '/Admin/ModulesV2',
      label: 'Modules',
      href: `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.ModulesV2}`,
    },
    {
      id: '/Admin/TrackmanParameters',
      label: 'Trackman Parameters',
      href: `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.TrackmanParametersList}`,
    },
    {
      id: '/Admin/TrackmanParametersV2',
      label: 'Trackman Parameters V2 (in development)',
      href: `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.TrackmanParametersListV2}`,
    },
    {
      id: '/Admin/UserManagement',
      label: 'Users',
      href: `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.UserManagement}`,
    },
    { id: '/Admin/Translation', label: 'Translation', href: `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.Translation}` },
    {
      id: '/Admin/Organizations',
      label: 'Organization List',
      href: `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.OrganizationsList}`,
    },
    {
      id: '/Admin/TestInvitations',
      label: 'Test Invitations',
      href: `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.TestInvitations}`,
    },
    {
      id: '/Admin/Partners',
      label: 'Partners List',
      href: `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.PartnersList}`,
    },
    {
      id: '/Admin/Masters',
      label: 'Masters List',
      href: `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.MastersList}`,
    },
    {
      id: '/Admin/TourAverages',
      label: 'Tour Averages',
      href: `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.TourAverages}`,
    },
    {
      id: '/Admin/Events',
      label: 'Events List',
      href: `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.EventsList}`,
    },
    {
      id: '/Admin/Analytics',
      label: 'Analytics',
      href: `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.Analytics}`,
    },
  ];
};

const getResourcesSubmenuItems = () => {
  return [
    {
      id: '/Resources/MenuTrackmanPortal',
      label: i18n.t('Portal', { ns: 'general' }),
      onClick: () => window.open('https://portal.trackmangolf.com/', '_blank'),
    },
    {
      id: '/Resources/MenuTrackmanCom',
      label: i18n.t('TrackmanCom', { ns: 'general' }),
      onClick: () => window.open('https://www.trackman.com/', '_blank'),
    },
    {
      id: '/Resources/MenuUpgameByTrackman',
      label: i18n.t('UpgameByTrackman', { ns: 'general' }),
      onClick: () => {
        if (window.screen.width >= 1024) {
          window.open('https://www.upgame.app/', '_blank');
        } else {
          setTimeout(function () {
            window.open('https://apps.apple.com/in/app/upgame-golf/id1221028917', '_blank');
          }, 25);
          window.location.href = 'upgame-golf://';
        }
      },
    },
    {
      id: '/Resources/MenuSupport',
      label: i18n.t('Support', { ns: 'general' }),
      onClick: () => window.open('https://support.trackmangolf.com/hc', '_blank'),
    },
  ];
};

export const getMenuItemIdsRoutesMap = () => {
  return {
    '/Home': [DefaultRoutes.Home],
    '/TrackmanParameters': [DefaultRoutes.TrackmanParameters],
    '/LearningHub': [DefaultRoutes.LearningHub],
    '/Webshop': [DefaultRoutes.Webshop],
    '/MastersAndPartners': [DefaultRoutes.Certifications],
    '/TrackmanEvents': [DefaultRoutes.TrackmanEvents],
    '/Organization': [DefaultRoutes.Organization],
    '/Admin/ModulesV2': [
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.ModulesV2}`,
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.ModulesV2}/${AdminModulesV2RelativeRoutes.ModuleItem}`,
    ],
    '/Admin/TrackmanParameters': [
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.TrackmanParametersList}`,
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.TrackmanParametersEditor}`,
    ],
    '/Admin/TrackmanParametersV2': [
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.TrackmanParametersListV2}`,
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.TrackmanParameterCategories}`,
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.TrackmanParametersEditorV2}`,
    ],
    '/Admin/UserManagement': [`${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.UserManagement}`],
    '/Admin/Translation': [`${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.Translation}`],
    '/Admin/Organizations': [
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.OrganizationsList}`,
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.EditOrganizationItem}`,
    ],
    '/Admin/TestInvitations': [`${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.TestInvitations}`],
    '/Admin/Partners': [
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.PartnersList}`,
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.PartnersEditor}`,
    ],
    '/Admin/Masters': [
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.MastersList}`,
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.MastersEditor}`,
    ],
    '/Admin/TourAverages': [`${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.TourAverages}`],
    '/Admin/Events': [
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.EventsList}`,
      `${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.EventEditor}`,
    ],
    '/Admin/Analytics': [`${DefaultRoutes.Admin}/${AdminPagesRelativeRoutes.Analytics}`],
  };
};

export const getTabsRoutesMap = () => {
  return {
    '/MastersAndPartners': CertificationsTabsRelativeRoutes,
    '/Profile': ProfileTabsRelativeRoutes,
    '/Organization': OrganizationTabsRelativeRoutes,
    '/Admin/ModulesV2/ModuleEditor': AdminModuleTabs,
    '/Admin/Analytics': AnalyticsTabsRelativeRoutes,
  };
};

const isPathMatch = (pathname: string, route: string) => pathname === route || pathname.startsWith(`${route}/`);

export const getMatchingMenuItem = (routesMap: Record<string, string[]>, pathname: string) => {
  return Object.entries(routesMap).find(([_, routes]) => routes.some((r) => isPathMatch(pathname, r)));
};

export const getMatchingTab = (routesMap: Record<string, Record<string, string>>, pathname: string): number | undefined => {
  const pathnameTabs = Object.entries(routesMap).find(([key, tabs]) => pathname.startsWith(key));
  if (!pathnameTabs) {
    return undefined;
  }
  const splitPathname = pathname.split('/');
  const tabs = Object.values(pathnameTabs[1]);
  const indexOfLastElement = tabs.indexOf(splitPathname[splitPathname.length - 1]);
  const indexOfTabFromRoute = splitPathname.length > 2 && indexOfLastElement !== -1 ? indexOfLastElement : 0;
  return indexOfTabFromRoute;
};
